module.exports = __webpack_public_path__ + "static/media/squats.eaeef674.mov";